import { axiosInstanceWebsite } from "../instance";

export interface DropiIntegrationInterface {
    integration_token: string;
    is_active: boolean;
}

export const getDropiIntegrations = async () => {
    const response = await axiosInstanceWebsite.get(`/order/dropi/integration`);
    return response.data;
};

export const postDropiIntegration = async (data: DropiIntegrationInterface) => {
    const response = await axiosInstanceWebsite.post(`/order/dropi/integration`, data);
    return response.data;
};